import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { json2csvAsync } from 'json-2-csv';
import axios from 'axios';
import TableParticipants from './TableParticipants';
import Spinner from '../../../components/Spinner/Spinner';
import getSchoolAndDistrict from '../../../utilities/getSchoolAndDistrict';
import { Button, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import downloadCSV from '../../../utilities/downloadCSV';

const PriorityParticipants = props => {
  const initState = {
    // searchInput: { firstName: "", lastName: "", birthDate: "", studentId: "" },
    searchResults: null,
  };
  const [state, setState] = useState(initState);

  const [isLoading, setIsLoading] = useState(false);

  const { schoolId, districtId } = getSchoolAndDistrict(props.navigation.org);
  useEffect(() => {
    searchParticipants();
  }, [districtId, schoolId]);

  // const handleWithinLastChange = (event) => {
  //   const value = event.target.value;
  //   setState(prevState => ({
  //     ...prevState,
  //     withinLast: value,
  //   }));
  // }
  const searchParticipants = async () => {
    if (districtId) {
      setIsLoading(true);
      const formData = new FormData(document.getElementById('searchParams'));
      const params = {
        orgId: schoolId ? schoolId : undefined,
        priority: 2,
        withinLast: formData.get("withinLast") > 0 ? formData.get("withinLast") : '',
        count: formData.get("count") > 0 ? formData.get("count") : ''
      }
      console.log(`search params:`, params)
      const url = `${process.env.REACT_APP_API_URL}/${districtId}/participant/search`;
      const response = await axios({
        url,
        method: 'GET',
        headers: {
          Authorization: props.idToken,
        },
        params,
      });
      console.log(`search results count:`, response.data.searchResult.length)
      setState(prevState => ({
        ...prevState,
        searchResults: response.data.searchResult,
      }));
      setIsLoading(false);
    }
  };
  const downloadResults = async () => {
    const csvString = await json2csvAsync(state.searchResults, {
      emptyFieldValue: '', keys: [
        { field: 'lastName', title: 'Last Name' },
        { field: 'firstName', title: 'First Name' },
        { field: 'middleName', title: 'Middle Name' },
        { field: 'grade', title: 'Grade' },
        { field: 'studentId', title: 'Student ID' },
        { field: 'priority', title: 'Priority' },
        { field: 'contacted', title: 'Has been contacted' },
        { field: 'referredTo', title: 'Was referred to' },
        { field: 'notes', title: 'Notes' },
        { field: 'survey.surveyName', title: 'Assessment Name' },
        { field: 'survey.semester', title: 'Semester' },
        { field: 'survey.year', title: 'Year' },
        { field: 'surveyResultIsValid', title: 'Result Valid' },
      ]
    })
    const filename = `Priority Participants ${props.navigation.org.name}.csv`
    downloadCSV({ csvBlob: new Blob([csvString], { type: 'text/csv' }), filename })
  };

  return (
    <div className="col">
      <h2>Participants marked Priority 1 and 2</h2>
      {districtId ? <div>These are the participants which were marked as Priority 1 or 2. You may use the controls below to search further back in time, or retrieve more results.</div> : <div>Please Select District first.</div>}
      <Form id="searchParams" >
        <FormGroup row className="border rounded d-flex align-items-center m-2 p-2">
          <Label sm={1} for='withinLast'>Within:</Label>
          <Col sm={3}>
            <Input name='withinLast' type='select' defaultValue="180">
              <option value="180">Last 6 months</option>
              <option value="365">Last Year</option>
              <option value="730">Last 2 years</option>
              <option value={-1}>All history</option>
            </Input>
          </Col>
          <Label sm={1} for='count'>Limit:</Label>
          <Col sm={3}>
            <Input name='count' type='select' defaultValue="100">
              <option value="100">100 participants</option>
              <option value="200">200 participants</option>
              <option value="500">500 participants</option>
              <option value={-1}>No limit</option>
            </Input>
          </Col>
          <Col sm={4}>
            <Button className="me-2" color="primary" onClick={searchParticipants}>{isLoading && <FontAwesomeIcon icon={faSpinner} className='fa-spin me-2' />}Apply</Button>
            <Button onClick={downloadResults}><FontAwesomeIcon icon={faDownload} className='me-2' /> Download <span className='fst-italic'>({state.searchResults?.length})</span></Button>
          </Col>
        </FormGroup>
      </Form>
      {state.searchResults && districtId && <TableParticipants participants={state.searchResults} />}
      {isLoading && (
        <div className="d-flex justify-content-center ">
          <Spinner />
        </div>
      )}
    </div>
  );
};
const mapStateToProps = state => {
  return {
    users: state.users.users,
    navigation: state.navigation,
    isUsersLoaded: state.users.isLoaded,
    role: state.auth.role,
    realRole: state.auth.realRole,
    idToken: state.auth.idToken,
  };
};

export default connect(mapStateToProps)(withRouter(PriorityParticipants));
